import React from "react";

import DefaultConfig from "../config";
import DefaultStyle from "../style/main.scss";
import DefaultLogo from "../assets/logo-white.png";
import DefaultSmallLogo from "../assets/gymshim-logo-icon.png";

import AgmConfig from "./agm/config";
import AgmLogo from "./agm/assets/agm-concept-logo-rgb.png";
import AgmLogoWhite from "../assets/agm-white-logo.png";
import AgmLogoSmall from "./agm/assets/agm-logo-small.png";

import JeraiConfig from "./jerai/config"
import JeraiLogo from "./jerai/assets/jerai-logo.png";
import JeraiLogoSmall from "./jerai/assets/jerai-logo-small.png";


// Signin
const Signin = React.lazy(() => import('../core/Signin'));
const AgmSignin = React.lazy(() => import('./agm/features/signin'));
const JeraiSignin = React.lazy(()=> import('./jerai/features/signin'))
 

// Home
const HomeDashboard = React.lazy(() => import('../features/dashboard/index'));
const AgmHome = React.lazy(() => import('./agm/features/home/index'));
const JeraiHome = React.lazy(()=> import('./jerai/features/home/index'))

const CLIENT = process.env.REACT_APP_CLIENT;

if (CLIENT === "agm") {
  import("./agm/theme.scss");
}else if (CLIENT === "jerai"){
  import("./jerai/theme.scss");
}else{
  import("../style/global.scss");
}

const clients = {
  gymshim: {
    type : "gymshim",
    config: DefaultConfig,
    style: DefaultStyle,
    logoIcon: DefaultSmallLogo,
    logo: DefaultLogo,
    signin: Signin,
    home: HomeDashboard,
  },

  agm: {
    type : "agm",
    config: AgmConfig,
    style: DefaultStyle,
    logoIcon: AgmLogoSmall,
    logo: AgmLogo,
    logoWhite: AgmLogoWhite,
    signin: AgmSignin,
    home: AgmHome,
    features: {
      Home: true,
      Enquiries: true,
      Members: true,
      Appointments: true,
      FollowUps: true,
      MembershipPlans: true,
      Memberships: true,
      PersonalTraining: true,
      Payments: true,
      SalesReport: true,
      Employees: true,
      Users: true
    }
  },
  
  jerai: {
    type: "jerai",
    config: JeraiConfig,
    style: DefaultStyle,
    logoIcon: JeraiLogoSmall,
    logo: JeraiLogo,
    signin: JeraiSignin,
    home: JeraiHome,
    features: {
      Home: true,
      Enquiries: true,
      Members: true,
      FollowUps: true,
      MembershipPlans: true,
      Memberships: true,
      PersonalTraining: true,
      Payments: true,
      SalesReport: true,
      Employees: true,
      Expense: true,
      Users: true,
      Configurations: true
      
    }
  }
};

export default clients[CLIENT] || clients.gymshim;